<div class="cic" data-testid="ci-confirm">
  @if (encryptQuestions().length > 0 || existingRows().length > 0) {
    <div class="cic-questions" data-testid="ci-questions">
      @if (encryptQuestions(); as questions) {
        @if (questions.length > 0) {
          <section class="cic-card" data-testid="ci-question-encrypt">
            <h3 class="cic-card__title">
              <mat-icon aria-hidden="true">key</mat-icon>
              <span class="cic-card__title-text">
                @if (questions.length === 1) {
                  {{ 'classicImport.confirm.encryptTitleOne' | translate }}
                } @else {
                  {{ 'classicImport.confirm.encryptTitleOther' | translate: { n: questions.length } }}
                }
              </span>
            </h3>
            <ul class="cic-encrypt">
              @for (q of questions; track q.id) {
                <li class="cic-encrypt__entry">
                  <span class="cic-encrypt__text">{{ q.text }}</span>
                  <mat-radio-group
                    class="cic-choice"
                    [attr.aria-label]="'classicImport.confirm.answerLabel' | translate: { text: q.text }"
                    [value]="answers()[q.id]"
                    [disabled]="busy()"
                    (change)="choose(q.id, $event.value)"
                  >
                    <mat-radio-button value="ENCRYPT">
                      {{ 'classicImport.confirm.encrypt' | translate }}
                    </mat-radio-button>
                    <mat-radio-button value="KEEP">{{ 'classicImport.confirm.keep' | translate }}</mat-radio-button>
                  </mat-radio-group>
                </li>
              }
            </ul>
          </section>
        }
      }

      @if (existingRows(); as rows) {
        @if (rows.length > 0) {
          <section class="cic-card" data-testid="ci-question-existing">
            <div class="cic-card__head">
              <h3 class="cic-card__title">
                <mat-icon aria-hidden="true">sync_alt</mat-icon>
                <span class="cic-card__title-text">
                  @if (rows.length === 1) {
                    {{ 'classicImport.confirm.existingTitleOne' | translate }}
                  } @else {
                    {{ 'classicImport.confirm.existingTitleOther' | translate: { n: rows.length } }}
                  }
                </span>
              </h3>
              <div class="cic-card__actions">
                <button
                  type="button"
                  class="cic-btn"
                  data-testid="ci-existing-replace-all"
                  [disabled]="busy()"
                  (click)="chooseAllExisting(replace)"
                >
                  {{ 'classicImport.confirm.replaceAll' | translate }}
                </button>
                <button
                  type="button"
                  class="cic-btn"
                  data-testid="ci-existing-skip-all"
                  [disabled]="busy()"
                  (click)="chooseAllExisting(skip)"
                >
                  {{ 'classicImport.confirm.skipAll' | translate }}
                </button>
              </div>
            </div>
            <button
              type="button"
              class="cic-toggle"
              data-testid="ci-existing-toggle"
              aria-controls="cic-existing-list"
              [attr.aria-expanded]="listOpen()"
              (click)="listOpen.set(!listOpen())"
            >
              <mat-icon aria-hidden="true">{{ listOpen() ? 'expand_less' : 'expand_more' }}</mat-icon>
              {{ (listOpen() ? 'classicImport.confirm.hideList' : 'classicImport.confirm.showList') | translate }}
            </button>
            @if (listOpen()) {
              <ul class="cic-existing" id="cic-existing-list">
                @for (row of rows; track row.question.id) {
                  <li class="cic-existing__row">
                    @if (row.type; as type) {
                      <mat-icon
                        class="cic-existing__icon"
                        role="img"
                        [attr.aria-label]="'classicImport.tree.types.' + type | translate"
                      >
                        {{ icons[type] }}
                      </mat-icon>
                    }
                    <span class="cic-existing__name">{{ row.name }}</span>
                    <mat-radio-group
                      class="cic-choice"
                      [attr.aria-label]="'classicImport.confirm.existingLabel' | translate: { name: row.name }"
                      [value]="answers()[row.question.id]"
                      [disabled]="busy()"
                      (change)="choose(row.question.id, $event.value)"
                    >
                      <mat-radio-button value="REPLACE">
                        {{ 'classicImport.confirm.replace' | translate }}
                      </mat-radio-button>
                      <mat-radio-button value="SKIP">{{ 'classicImport.confirm.skip' | translate }}</mat-radio-button>
                    </mat-radio-group>
                  </li>
                }
              </ul>
            }
          </section>
        }
      }
    </div>
  }

  <section class="cic-summary">
    <h3 class="cic-summary__title">{{ 'classicImport.confirm.summaryTitle' | translate }}</h3>
    <p class="cic-summary__text" data-testid="ci-summary">
      {{ 'classicImport.confirm.summary' | translate: summary() }}
    </p>
  </section>
</div>
